module.exports = "<career-circle item=\"job\" ng-repeat=\"job in ::vm.jobFamily.jobs track by $index\"></career-circle>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/careerOpps/careerOpps.html
// module id = 102
// module chunks = 0 1